/**
 * POS sync run polling helpers (Vue 2 — use via store actions or import constants).
 */

import { buildPosSyncRunCounters } from '@/composables/posSyncRunCounters';

export const POLL_INTERVAL_MS = 1000;

export const TERMINAL_RUN_STATUSES = [
    'success',
    'success_with_warnings',
    'error',
    'cancelled',
    'failed',
];

export function isRunTerminal(status) {
    if (!status) {
        return false;
    }
    return !['pending', 'running'].includes(status);
}

/**
 * Normalize run payload from list/detail API for UI components.
 */
export function normalizeRun(run) {
    if (!run) {
        return null;
    }
    const started = run.started_at || run.triggered_date;
    const finished = run.finished_at || run.sync_date;
    let durationSeconds = run.duration_seconds;
    if (durationSeconds == null && started && finished) {
        const startMs = new Date(started).getTime();
        const endMs = new Date(finished).getTime();
        if (!Number.isNaN(startMs) && !Number.isNaN(endMs)) {
            durationSeconds = Math.max(0, Math.floor((endMs - startMs) / 1000));
        }
    }
    return {
        ...run,
        started_at: started,
        finished_at: finished,
        action_type: run.action_type || run.action,
        counters: buildPosSyncRunCounters(run),
        duration_seconds: durationSeconds,
        current_step_label: run.current_step_label || null,
        errors: run.errors || run.errors_preview || [],
    };
}

export function runFinishedToastKey(status) {
    const map = {
        success: 'posSync.run.finishedSuccess',
        success_with_warnings: 'posSync.run.finishedWarnings',
        error: 'posSync.run.finishedError',
        cancelled: 'posSync.run.finishedCancelled',
        failed: 'posSync.run.finishedError',
    };
    return map[status] || null;
}
